import PropTypes from 'prop-types'

export const ARTICLE_TYPE = PropTypes.shape({
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
})

export const ARTICLES_TYPE = PropTypes.arrayOf(ARTICLE_TYPE)

export const PAGE_NAVIGATION_ITEM_TYPE = PropTypes.shape({
  label: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
})

export const PAGE_NAVIGATION_ITEMS_TYPE = PropTypes.arrayOf(
  PAGE_NAVIGATION_ITEM_TYPE,
)

export const ASIDE_LIST_ITEM_TYPE = PropTypes.shape({
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  image: PropTypes.string.isRequired,
  linkPath: PropTypes.string.isRequired,
})

export const ASIDE_LIST_TYPE = PropTypes.arrayOf(ASIDE_LIST_ITEM_TYPE)

export const TOP_ARTICLE_TYPE = PropTypes.shape({
  author: PropTypes.string.isRequired,
  average: PropTypes.string,
  category: PropTypes.shape({
    createdAt: PropTypes.string,
    featuredArticleId: PropTypes.string,
    featuredInstructorSlug: PropTypes.string,
    id: PropTypes.string.isRequired,
    imageId: PropTypes.string,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    updatedAt: PropTypes.string,
  }).isRequired,
  description: PropTypes.string.isRequired,
  heroImage: PropTypes.shape({
    content_type: PropTypes.string,
    createdAt: PropTypes.string,
    description: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    updatedAt: PropTypes.string,
    url: PropTypes.string.isRequired,
  }),
  id: PropTypes.number.isRequired,
  instructorSlug: PropTypes.string.isRequired,
  ratingsCount: PropTypes.number,
  slug: PropTypes.string,
  title: PropTypes.string.isRequired,
  titleTag: PropTypes.any,
  updatedAt: PropTypes.string,
})

export const TOP_ARTICLES_TYPE = PropTypes.arrayOf(TOP_ARTICLE_TYPE)

export const NORMAL_SUBSECTION_TYPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  entityType: PropTypes.string,
})

export const RECIPE_SUBSECTION_TYPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  entityType: PropTypes.string,
  title: PropTypes.string.isRequired,
  cookTime: PropTypes.string,
  keywords: PropTypes.arrayOf(PropTypes.string),
  prepTime: PropTypes.string,
  recipeCategory: PropTypes.string,
  recipeCuisine: PropTypes.string,
  recipeIngredient: PropTypes.string,
  recipeInstructions: PropTypes.string,
  recipeYield: PropTypes.string,
  totalTime: PropTypes.string,
})

export const SUBSECTION_TYPE = PropTypes.oneOf([
  NORMAL_SUBSECTION_TYPE,
  RECIPE_SUBSECTION_TYPE,
])

export const SUBSECTIONS_TYPE = PropTypes.arrayOf(
  PropTypes.oneOf([NORMAL_SUBSECTION_TYPE, RECIPE_SUBSECTION_TYPE]),
)

export const SUBSECTION_VIDEOGEM_TYPE = PropTypes.arrayOf(
  PropTypes.shape({
    videoId: PropTypes.string.isRequired,
    mediaUuid: PropTypes.string,
    videoName: PropTypes.string,
  }),
)

export const SOCIAL_SHARE_LINKS_TYPE = PropTypes.shape({
  facebook: PropTypes.string.isRequired,
  twitter: PropTypes.string.isRequired,
  mail: PropTypes.string.isRequired,
})
